/**
 * 실제 Iceberg 데이터
 * Gold, Silver, Bronze 레이어의 실제 OpenMetadata 검색 결과
 */
import type { OpenMetadataHit, OpenMetadataResponse } from '@/shared/api/openmetadata/types';

import { icebergBronzeData } from './iceberg-bronze';
import { icebergGoldData } from './iceberg-gold';
import { icebergSilverData } from './iceberg-silver';

const EXCLUDED_BRONZE_TABLES = ['tag_id_mapping_table', 'hanwha_impact_rpm_tag_id_map'];

const asOpenMetadataHits = (hits: unknown): OpenMetadataHit[] => hits as OpenMetadataHit[];

/**
 * Bronze 데이터에서 제외할 테이블을 필터링
 */
const filterBronzeData = (hits: OpenMetadataHit[]): OpenMetadataHit[] => {
  return hits.filter((hit) => {
    if (!hit._source) return false;
    const source = hit._source;
    return !EXCLUDED_BRONZE_TABLES.includes(source.name) && !EXCLUDED_BRONZE_TABLES.includes(source.displayName || '');
  });
};

/**
 * Gold 레이어 데이터 (6개 테이블)
 */
export const GOLD_DATA: OpenMetadataHit[] = asOpenMetadataHits(icebergGoldData.hits.hits);

/**
 * Silver 레이어 데이터 (6개 테이블)
 */
export const SILVER_DATA: OpenMetadataHit[] = asOpenMetadataHits(icebergSilverData.hits.hits);

/**
 * Bronze 레이어 데이터 (제외 테이블 필터링 후 12개 테이블)
 */
export const BRONZE_DATA: OpenMetadataHit[] = filterBronzeData(asOpenMetadataHits(icebergBronzeData.hits.hits));

/**
 * 전체 Iceberg 데이터 (Gold + Silver + Bronze)
 * 전체 hit 객체를 유지하여 원본 _id 보존
 */
export const ALL_ICEBERG_DATA: OpenMetadataHit[] = [...GOLD_DATA, ...SILVER_DATA, ...BRONZE_DATA];

/**
 * 전체 OpenMetadata Response (검색 API 응답 형식)
 */
export const FULL_ICEBERG_RESPONSE: OpenMetadataResponse = {
  took: 5,
  timed_out: false,
  _shards: {
    total: 22,
    successful: 22,
    skipped: 20,
    failed: 0,
  },
  hits: {
    total: {
      value: ALL_ICEBERG_DATA.length,
      relation: 'eq',
    },
    max_score: 0,
    hits: ALL_ICEBERG_DATA,
  },
};

// 중복 체크 (개발용)
const allIds = ALL_ICEBERG_DATA.map((hit) => hit._id);
const uniqueIds = new Set(allIds);

if (allIds.length !== uniqueIds.size) {
  console.error('[IcebergData] 중복된 _id 발견!');
  const idCount = new Map<string, number>();
  allIds.forEach((id) => idCount.set(id, (idCount.get(id) || 0) + 1));
  idCount.forEach((count, id) => {
    if (count > 1) console.error(`  ${id}: ${count}번`);
  });
}
